import React from 'react';
import Form from '../components/Form/Form';

const SignupPage = () => {
	return <Form />;
};

export default SignupPage;
